import React from 'react'
import './Registration.css'
import { Logo } from '../../../utils'
import SignupFunction from '../../../utils/CommonFunctionality/SignupFunction'
import Layout from '../Layout'
import SignupStepperFunction from '../../../utils/CommonFunctionality/SignupStepperFunction'
const Registration = (props) => {
    const isVarifiedGfTheme = global.storeConfigration?.bodyClass?.value === 'greenField'
    return (
        <Layout props={props}>
            <div className="clearfix row regCnt">
                <div className="col-lg-3 d-none d-lg-block pad-0">
                    {/*<div className="loginImgBox d-flex justify-content-between flex-column"></div>*/}
                </div>
                <div className="col-lg-6 col-12">
                    <div className="loginFormBox">
                        {!isVarifiedGfTheme && <Logo className="m-auto" />}
                        {global.storeConfigration.signupVerify.value ? (
                            <SignupStepperFunction title="Sign Up" />
                        ) : (
                            <SignupFunction
                                // phone_country_code_must={true}
                                title="Sign Up"
                                subTitle="Create Your Free Account"
                            />
                        )}
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default Registration
